import React from 'react';
import { Box, Button, Group, Select, TextInput, Text } from '@mantine/core';
import { IconClearAll, IconSearch } from '@tabler/icons-react';
import type { IFiltroMaterialesVistaProps } from '../interfaces';

const FiltroMaterialesVista: React.FunctionComponent<IFiltroMaterialesVistaProps> = ({
  consultarMateriales,
  filtro,
  manejarCambioFiltroMaterial,
  tiposMateriales,
  limpiarFiltros
}) => {

  return (
    <Box mb="md" p="xs" >
      <Group align="end">
        <TextInput
          label="Buscar por código"
          placeholder="Código"
          size='xs'
          maxLength={15}
          value={filtro.Sku}
          onChange={(event) => {
            const regex = /^[A-Za-z0-9-_]*$/;
            if (regex.test(event.currentTarget.value)) {
              manejarCambioFiltroMaterial('Sku', event.currentTarget.value)
            }
          }
          }
        // style={{ flex: 1 }}
        />
        <Select
          label="Tipo de material"
          placeholder="Seleccione un tipo"
          data={tiposMateriales.map(tp => ({
            value: tp.Id.toString(),
            label: tp.Nombre
          }))}
          size='xs'
          value={filtro.TipoMaterialId ? filtro.TipoMaterialId.toString() : null}
          onChange={(value) => manejarCambioFiltroMaterial('TipoMaterialId', value ? parseInt(value) : 0)}
          style={{ minWidth: 200 }}
        />
        <Button
          onClick={limpiarFiltros}
          color="primary"
          variant="light"
          size="compact-sm"
          radius="lg"
          rightSection={<IconClearAll opacity={1} size={12} />}
        >
          <Text fw={500} fz={11}>Limpiar</Text>
        </Button>

        <Button
          onClick={() => consultarMateriales(filtro, {Page: 1, Size: 10})}
          color="primary"
          variant="filled"
          size="compact-sm"
          radius="lg"
          rightSection={<IconSearch opacity={1} size={12} />}
        >
          <Text fw={500} fz={11}>Consultar</Text>
        </Button>
      </Group>
    </Box>
  );
};

export default React.memo(FiltroMaterialesVista);
